module.exports = __webpack_public_path__ + "static/media/026.2ef2bea8.jpg";